'use client';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function AnchorNav() {
  const { language } = useLanguage();
  const t = getTranslations(language);

  const handleScroll = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className="flex items-center gap-1">
      <a
        href="#converter"
        onClick={(e) => handleScroll(e, '#converter')}
        className="px-3 py-1.5 text-sm font-semibold text-muted-foreground hover:text-primary hover:bg-primary/8 rounded-md transition-all duration-150 whitespace-nowrap"
      >
        {t.navConverter}
      </a>
    </nav>
  );
}